@if (auth.loading()) {
  <div class="loading-screen">
    <mat-spinner diameter="48" />
    <p>Loading ViTails...</p>
  </div>
} @else {
  <router-outlet />
}
